<template>
    <router-view></router-view>
</template>
<script>
    export default{
        data () {
            return {}
        },
        components: {},
        methods: {}
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// layout-auth.vue?6e14d3f1